var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-image" },
    [
      _c(
        "router-link",
        { staticClass: "product-link", attrs: { to: _vm.path } },
        [
          _c("div", { staticClass: "image-container" }, [
            _c(
              "div",
              { staticClass: "image" },
              [
                _c("AImage", {
                  attrs: {
                    img: _vm.image,
                    alt: _vm.title,
                    title: _vm.title,
                    preset: "wineproductteaser",
                    contain: "",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }